export default __webpack_public_path__ + "static/media/1.0667a2de.webp";